import { Box } from '@material-ui/core'
import history from '../../routes/history'
import RightArrow from '../../svgs/rightarrow'
import { useStyles } from './styles'
const BreadCrumb = (props) => {
  const { sequences } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      {sequences?.map((object, index) => {
        return index != sequences.length - 1 ? (
          <Box className={classes.elementlayout}>
            <Box
              style={{
                padding: '0px 10px',
                color: '#9F9E9E',
                cursor: 'pointer',
              }}
              onClick={() => {
                history.push('/installer')
              }}
            >
              {object}
            </Box>
            <RightArrow></RightArrow>
          </Box>
        ) : (
          <Box className={classes.elementlayout}>
            <Box style={{ padding: '0px 10px', color: '#F37320' }}>
              {object}
            </Box>
          </Box>
        )
      })}
    </div>
  )
}
export default BreadCrumb
